import { get, isObject } from "lodash-es";
import { schemaProcessFuncFactory } from "./common";
const listData = 'listData';
export const listDataProcess = {
  stateModel: 'list_JS',
  variableName: listData,
  main: true,
  show: ({
    instance
  }) => {
    const value = get(instance, listData);
    return Array.isArray(value) && isObject(value[0]);
  },
  func: schemaProcessFuncFactory(listData)
};
const formData = 'formData';
export const formDataProcess = {
  stateModel: 'form_JS',
  variableName: formData,
  main: true,
  show: ({
    instance
  }) => {
    const value = get(instance, formData);
    return hasValueOrHasFields(value);
  },
  func: schemaProcessFuncFactory(formData)
};
const [anyDataProcess, anyQueryProcess, anyBodyProcess] = ['data', 'query', 'body'].map(key => {
  const processItem = {
    stateModel: 'any_JS',
    variableName: key,
    main: true,
    show: ({
      instance
    }) => {
      var _instance$stateSchema;
      const field = (_instance$stateSchema = instance.stateSchema.fields) === null || _instance$stateSchema === void 0 ? void 0 : _instance$stateSchema.find(item => item.id === key);
      if (!field || field.hidden === true) {
        return false;
      }
      const value = get(instance, key);
      return hasValueOrHasFields(value);
    },
    func: schemaProcessFuncFactory(key)
  };
  return processItem;
});
export const schemaProcesses = [listDataProcess, formDataProcess, anyDataProcess, anyQueryProcess, anyBodyProcess].map(item => Object.freeze(item));
function hasValueOrHasFields(value) {
  if (isObject(value)) {
    return Object.keys(value).length > 0;
  }
  return Boolean(value);
}
//# sourceMappingURL=processes.js.map
